import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Menu = (props) => {
  return (
    <div className="menu-wrapper">
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={() => props.SetMenuIsOpen(!props.MenuIsOpen)}
        sx={{
          color: "#FB4764",
        }}
      >
        <MenuIcon />
      </IconButton>
    </div>
  );
};

export default Menu;
